// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2VOqK","list":"styles_list__1EqR9"};